import React from 'react';
import { MinusIcon, PlusIcon } from '../../helpers/Icons';

const NumberInput = ({ label, val, onChange, placeholder, color, type = 'text', onStep, field, theme, point, onInitialize }) => (
  <div>
    <div style={{ fontSize: 10, color: theme.textM, marginBottom: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span>{label}</span>
      {onInitialize && field && <span onClick={() => onInitialize(field)} style={{ cursor: 'pointer', color: theme.primaryL, fontSize: 9 }}>Current</span>}
    </div>
    <div style={{ display: 'flex', alignItems: 'center', background: theme.card2, border: `1px solid ${color || theme.border}`, borderRadius: 5, overflow: 'hidden', height: 30 }}>
      {onStep && (
        <button onClick={() => onStep(-point)} style={{ padding: '4px 6px', border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <MinusIcon s={10} c={theme.textS} />
        </button>
      )}
      <input
        type={type}
        value={val}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          flex: 1,
          minWidth: 0,
          background: 'transparent',
          border: 'none',
          padding: '5px 8px',
          color: theme.text,
          fontSize: 12,
          fontFamily: theme.mono,
          outline: 'none',
          textAlign: onStep ? 'center' : 'left',
          width: '100%',
          boxSizing: 'border-box',
          height: '100%',
        }}
      />
      {onStep && (
        <button onClick={() => onStep(point)} style={{ padding: '4px 6px', border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <PlusIcon s={10} c={theme.textS} />
        </button>
      )}
    </div>
  </div>
);

export default NumberInput;
